document.addEventListener('DOMContentLoaded', () => {
  const navItems = document.querySelectorAll('[data-megamenu-parent]');

  navItems.forEach(item => {
    const handle = item.dataset.megamenuParent;
    const menu = document.getElementById(`megamenu-${handle}`);
    if (!menu) return;

    let closeTimer;

    const open = () => {
      clearTimeout(closeTimer);
      document.querySelectorAll('.megamenu.is-visible').forEach(m => {
        if (m !== menu) m.classList.remove('is-visible');
      });
      menu.classList.add('is-visible');
    };

    const close = () => {
      closeTimer = setTimeout(() => menu.classList.remove('is-visible'), 120);
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    menu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    menu.addEventListener('mouseleave', close);

    // Hover on left-panel links swaps the right-panel image
    const triggers = menu.querySelectorAll('[data-megamenu-trigger]');
    const previews = menu.querySelectorAll('[data-megamenu-preview]');

    triggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => {
        const target = trigger.dataset.megamenuTrigger;
        triggers.forEach(t => t.classList.remove('is-active'));
        previews.forEach(p => p.classList.remove('is-active'));
        trigger.classList.add('is-active');
        const matchedPreview = menu.querySelector(`[data-megamenu-preview="${target}"]`);
        if (matchedPreview) matchedPreview.classList.add('is-active');
      });
    });
  });

  // Close on outside click
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-megamenu-parent]') && !e.target.closest('.megamenu')) {
      document.querySelectorAll('.megamenu.is-visible').forEach(m => m.classList.remove('is-visible'));
    }
  });
});